export default __webpack_public_path__ + "static/media/Snd1.bbd626cd.mp3";